import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-injury-previewinfo',
    templateUrl: './injury-previewinfo.component.html',
    styleUrls: ['./injury-previewinfo.component.css']
})
export class InjuryPreviewinfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
